
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5nRL1", function(module, exports) {
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b8b2d306bbe1b8cb$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window);
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(pageLayoutRoot, window);
        }
    }
}
/**
 * Gets the effective bounding rectangle for an element, handling display: contents elements
 * by collecting dimensions from their children instead
 */ function $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window) {
    const computedStyle = window.getComputedStyle(elem);
    // If element has display: contents, collect bounding rect from children
    if (computedStyle.display === 'contents') {
        const children = Array.from(elem.children);
        if (children.length === 0) // No children, return zero rect
        return new DOMRect(0, 0, 0, 0);
        // Calculate union of all children's bounding rects
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        children.forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            // Skip children with zero dimensions (likely also display: contents)
            if (childRect.width > 0 || childRect.height > 0) {
                minX = Math.min(minX, childRect.left);
                minY = Math.min(minY, childRect.top);
                maxX = Math.max(maxX, childRect.right);
                maxY = Math.max(maxY, childRect.bottom);
            }
        });
        // If no children with dimensions found, return zero rect
        if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    // Normal element, return its bounding rect
    return elem.getBoundingClientRect();
}
module.exports["collectSSRPlaceholderDimensions"] = $b8b2d306bbe1b8cb$export$aee7516e57289027;

});

parcelRegister("hZpML", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGrzq = parcelRequire("kGrzq");

var $37b533d524acf2b8$export$5cd865dcdb41adf = /*#__PURE__*/ function(WATERFALL_INITIAL_MEASURES) {
    WATERFALL_INITIAL_MEASURES["REDIRECTION"] = "wf/navigation/redirection";
    WATERFALL_INITIAL_MEASURES["DNS"] = "wf/navigation/dns";
    WATERFALL_INITIAL_MEASURES["TCP"] = "wf/navigation/tcp";
    WATERFALL_INITIAL_MEASURES["TLS"] = "wf/navigation/tls";
    WATERFALL_INITIAL_MEASURES["RESPONSE"] = "wf/navigation/response";
    WATERFALL_INITIAL_MEASURES["TTFB"] = "wf/navigation/ttfb";
    WATERFALL_INITIAL_MEASURES["FULL_HTML"] = "wf/navigation/fullHtml";
    WATERFALL_INITIAL_MEASURES["SERVER_TIMING"] = "wf/navigation/serverTiming";
    WATERFALL_INITIAL_MEASURES["CSS_MAIN"] = "wf/css/main";
    WATERFALL_INITIAL_MEASURES["CSS_SUPERBATCH"] = "wf/css/superbatch";
    WATERFALL_INITIAL_MEASURES["CSS_CONNECT_WEB_RESOURCES"] = "wf/css/connectWebResources";
    WATERFALL_INITIAL_MEASURES["CSS_COMPILED"] = "wf/css/compiled";
    WATERFALL_INITIAL_MEASURES["JS_SUPERBATCH"] = "wf/js/superbatch";
    WATERFALL_INITIAL_MEASURES["JS_CONNECT_WEB_RESOURCES"] = "wf/js/connectWebResources";
    WATERFALL_INITIAL_MEASURES["HTML_THEME_INIT"] = "wf/html/themeInit";
    WATERFALL_INITIAL_MEASURES["HTML_REACT_ROOT"] = "wf/html/reactRoot";
    WATERFALL_INITIAL_MEASURES["HTML_SSR_SCRIPTS"] = "wf/html/ssrScripts";
    WATERFALL_INITIAL_MEASURES["HTML_TOP_NAV"] = "wf/html/topNav";
    WATERFALL_INITIAL_MEASURES["HTML_SIDE_NAV"] = "wf/html/sideNav";
    WATERFALL_INITIAL_MEASURES["HTML_MAIN"] = "wf/html/main";
    WATERFALL_INITIAL_MEASURES["HTML_FORCE_LAYOUT"] = "wf/html/forceLayout";
    WATERFALL_INITIAL_MEASURES["SSR_GLOBALS"] = "wf/html/ssrGlobals";
    WATERFALL_INITIAL_MEASURES["COLLECT_PLACEHOLDER_DIMENSIONS"] = "wf/bootstrap/collectPlaceholderDimensions";
    WATERFALL_INITIAL_MEASURES["SSR_BEFORE_SCRIPTS"] = "wf/bootstrap/ssrBeforeScripts";
    WATERFALL_INITIAL_MEASURES["SSR_AFTER_SCRIPTS"] = "wf/bootstrap/ssrAfterScripts";
    WATERFALL_INITIAL_MEASURES["CREATE_APOLLO_CLIENTS"] = "wf/bootstrap/createApolloClients";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_SESSION_DATA"] = "wf/bootstrap/getSessionData";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_TRANSLATION"] = "wf/bootstrap/loadTranslation";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_LOADABLE"] = "wf/bootstrap/preloadLoadable";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_STORAGE_MANAGER"] = "wf/bootstrap/initializeStorageManager";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_COOKIES"] = "wf/bootstrap/initializeCookies";
    return WATERFALL_INITIAL_MEASURES;
}({});
const $37b533d524acf2b8$export$deb9bd49feb08fb5 = [
    'atl-edge-internal',
    'atl-edge-upstream',
    'cdn-upstream-fbl',
    'cdn-upstream-dns',
    'cdn-upstream-connect',
    'cdn-downstream-fbl'
];
function $37b533d524acf2b8$export$61a691dabeb80f51(name) {
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window["__SSR_RENDERED__"]&&window.performance.mark("${name}");`
        }
    });
}
class $37b533d524acf2b8$var$WaterfallMeasure extends (0, $kGrzq.BaseMeasures) {
    markMeasureStart(name, timestamp) {
        this.markedKeys.add(name);
        window.performance.clearMarks(`${name}.start`);
        window.performance.mark(`${name}.start`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    markMeasureEnd(name, timestamp) {
        window.performance.clearMarks(`${name}.end`);
        window.performance.mark(`${name}.end`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    getMeasureKeys(after) {
        return Array.from(this.markedKeys).filter((key)=>{
            const mark = performance.getEntriesByName(`${key}.start`, 'mark');
            return mark.length && mark[0].startTime >= after;
        });
    }
    clearMeasures() {
        super.clearMeasures();
        this.markedKeys.clear();
    }
    constructor(...args){
        super(...args);
        this.markedKeys = new Set();
    }
}
const $37b533d524acf2b8$export$d7d6a49c52882aad = new $37b533d524acf2b8$var$WaterfallMeasure();
module.exports["WATERFALL_INITIAL_MEASURES"] = $37b533d524acf2b8$export$5cd865dcdb41adf;
module.exports["SERVER_TIMING_MEASURES"] = $37b533d524acf2b8$export$deb9bd49feb08fb5;
module.exports["perfMark"] = $37b533d524acf2b8$export$61a691dabeb80f51;
module.exports["WaterfallMeasures"] = $37b533d524acf2b8$export$d7d6a49c52882aad;

});

parcelRegister("42omo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6pzYC"));

});

parcelRegister("6pzYC", function(module, exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ab0fc1563709023$export$dca3b0875bd9a954;
var $4ab0fc1563709023$export$16fa2f45be04daa8;
var $4ab0fc1563709023$export$ffb0004e005737fa;
var $4ab0fc1563709023$export$e2c29f18771995cb;
var $4ab0fc1563709023$export$221d75b3f55bb0bd;
var $4ab0fc1563709023$export$5f8d39834fd61797;
var $4ab0fc1563709023$export$74bf444e3cd11ea5;
var $4ab0fc1563709023$export$ae55be85d98224ed;
var $4ab0fc1563709023$export$3ba232387fd5d6dd;
var $4ab0fc1563709023$export$e530037191fcd5d7;
var $4ab0fc1563709023$export$fd42f52fd3ae1109;
var $4ab0fc1563709023$export$c8a8987d4410bf2d;
var $4ab0fc1563709023$export$d38cd72104c1f0e9;
var $4ab0fc1563709023$export$7d1e3a5e95ceca43;
var $4ab0fc1563709023$export$257a8862b851cb5b;
var $4ab0fc1563709023$export$a8257692ac88316c;
var $4ab0fc1563709023$export$488013bae63b21da;
var $4ab0fc1563709023$export$7c73462e0d25e514;
var $4ab0fc1563709023$export$7568632d0d33d16d;
var $4ab0fc1563709023$export$88948ce120ea2619;
var $4ab0fc1563709023$export$35808ee640e87ca7;
var $4ab0fc1563709023$export$fae74005e78b1a27;
var $4ab0fc1563709023$export$dc8fbce3eb94dc1e;
var $4ab0fc1563709023$export$6a7bc4e911dc01cf;
var $4ab0fc1563709023$export$6d9c69b0de29b591;
var $4ab0fc1563709023$export$f680877a34711e37;
var $4ab0fc1563709023$export$d5a552a76deda3c2;
var $4ab0fc1563709023$export$aaabe4eda9ed9969;
var $4ab0fc1563709023$export$e5c5a5f917a5871c;
var $4ab0fc1563709023$export$1538c33de8887b59;
var $4ab0fc1563709023$export$13e3392192263954;
var $4ab0fc1563709023$export$b8f5890fc79d6aca;
var $4ab0fc1563709023$export$60241385465d0a34;
var $4ab0fc1563709023$export$306c0aa65ff9ec16;
var $4ab0fc1563709023$export$7b286972b8d8ccbf;
var $4ab0fc1563709023$export$83d89fbfd8236492;
'use strict';
var $4ab0fc1563709023$var$l = Symbol.for("react.element"), $4ab0fc1563709023$var$n = Symbol.for("react.portal"), $4ab0fc1563709023$var$p = Symbol.for("react.fragment"), $4ab0fc1563709023$var$q = Symbol.for("react.strict_mode"), $4ab0fc1563709023$var$r = Symbol.for("react.profiler"), $4ab0fc1563709023$var$t = Symbol.for("react.provider"), $4ab0fc1563709023$var$u = Symbol.for("react.context"), $4ab0fc1563709023$var$v = Symbol.for("react.forward_ref"), $4ab0fc1563709023$var$w = Symbol.for("react.suspense"), $4ab0fc1563709023$var$x = Symbol.for("react.memo"), $4ab0fc1563709023$var$y = Symbol.for("react.lazy"), $4ab0fc1563709023$var$z = Symbol.iterator;
function $4ab0fc1563709023$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4ab0fc1563709023$var$z && a[$4ab0fc1563709023$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4ab0fc1563709023$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4ab0fc1563709023$var$C = Object.assign, $4ab0fc1563709023$var$D = {};
function $4ab0fc1563709023$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
$4ab0fc1563709023$var$E.prototype.isReactComponent = {};
$4ab0fc1563709023$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4ab0fc1563709023$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4ab0fc1563709023$var$F() {}
$4ab0fc1563709023$var$F.prototype = $4ab0fc1563709023$var$E.prototype;
function $4ab0fc1563709023$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
var $4ab0fc1563709023$var$H = $4ab0fc1563709023$var$G.prototype = new $4ab0fc1563709023$var$F;
$4ab0fc1563709023$var$H.constructor = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$var$C($4ab0fc1563709023$var$H, $4ab0fc1563709023$var$E.prototype);
$4ab0fc1563709023$var$H.isPureReactComponent = !0;
var $4ab0fc1563709023$var$I = Array.isArray, $4ab0fc1563709023$var$J = Object.prototype.hasOwnProperty, $4ab0fc1563709023$var$K = {
    current: null
}, $4ab0fc1563709023$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4ab0fc1563709023$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4ab0fc1563709023$var$J.call(b, d) && !$4ab0fc1563709023$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4ab0fc1563709023$var$K.current
    };
}
function $4ab0fc1563709023$var$N(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4ab0fc1563709023$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4ab0fc1563709023$var$l;
}
function $4ab0fc1563709023$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4ab0fc1563709023$var$P = /\/+/g;
function $4ab0fc1563709023$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4ab0fc1563709023$var$escape("" + a.key) : b.toString(36);
}
function $4ab0fc1563709023$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4ab0fc1563709023$var$l:
                case $4ab0fc1563709023$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4ab0fc1563709023$var$Q(h, 0) : d, $4ab0fc1563709023$var$I(c) ? (e = "", null != a && (e = a.replace($4ab0fc1563709023$var$P, "$&/") + "/"), $4ab0fc1563709023$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4ab0fc1563709023$var$O(c) && (c = $4ab0fc1563709023$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4ab0fc1563709023$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4ab0fc1563709023$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4ab0fc1563709023$var$Q(k, g);
        h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    }
    else if (f = $4ab0fc1563709023$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4ab0fc1563709023$var$Q(k, g++), h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4ab0fc1563709023$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4ab0fc1563709023$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4ab0fc1563709023$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4ab0fc1563709023$var$U = {
    current: null
}, $4ab0fc1563709023$var$V = {
    transition: null
}, $4ab0fc1563709023$var$W = {
    ReactCurrentDispatcher: $4ab0fc1563709023$var$U,
    ReactCurrentBatchConfig: $4ab0fc1563709023$var$V,
    ReactCurrentOwner: $4ab0fc1563709023$var$K
};
function $4ab0fc1563709023$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4ab0fc1563709023$export$dca3b0875bd9a954 = {
    map: $4ab0fc1563709023$var$S,
    forEach: function(a, b, e) {
        $4ab0fc1563709023$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4ab0fc1563709023$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4ab0fc1563709023$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4ab0fc1563709023$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4ab0fc1563709023$export$16fa2f45be04daa8 = $4ab0fc1563709023$var$E;
$4ab0fc1563709023$export$ffb0004e005737fa = $4ab0fc1563709023$var$p;
$4ab0fc1563709023$export$e2c29f18771995cb = $4ab0fc1563709023$var$r;
$4ab0fc1563709023$export$221d75b3f55bb0bd = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$export$5f8d39834fd61797 = $4ab0fc1563709023$var$q;
$4ab0fc1563709023$export$74bf444e3cd11ea5 = $4ab0fc1563709023$var$w;
$4ab0fc1563709023$export$ae55be85d98224ed = $4ab0fc1563709023$var$W;
$4ab0fc1563709023$export$3ba232387fd5d6dd = $4ab0fc1563709023$var$X;
$4ab0fc1563709023$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4ab0fc1563709023$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4ab0fc1563709023$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4ab0fc1563709023$var$J.call(b, f) && !$4ab0fc1563709023$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4ab0fc1563709023$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4ab0fc1563709023$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4ab0fc1563709023$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4ab0fc1563709023$export$c8a8987d4410bf2d = $4ab0fc1563709023$var$M;
$4ab0fc1563709023$export$d38cd72104c1f0e9 = function(a) {
    var b = $4ab0fc1563709023$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4ab0fc1563709023$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4ab0fc1563709023$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$v,
        render: a
    };
};
$4ab0fc1563709023$export$a8257692ac88316c = $4ab0fc1563709023$var$O;
$4ab0fc1563709023$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4ab0fc1563709023$var$T
    };
};
$4ab0fc1563709023$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4ab0fc1563709023$export$7568632d0d33d16d = function(a) {
    var b = $4ab0fc1563709023$var$V.transition;
    $4ab0fc1563709023$var$V.transition = {};
    try {
        a();
    } finally{
        $4ab0fc1563709023$var$V.transition = b;
    }
};
$4ab0fc1563709023$export$88948ce120ea2619 = $4ab0fc1563709023$var$X;
$4ab0fc1563709023$export$35808ee640e87ca7 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useCallback(a, b);
};
$4ab0fc1563709023$export$fae74005e78b1a27 = function(a) {
    return $4ab0fc1563709023$var$U.current.useContext(a);
};
$4ab0fc1563709023$export$dc8fbce3eb94dc1e = function() {};
$4ab0fc1563709023$export$6a7bc4e911dc01cf = function(a) {
    return $4ab0fc1563709023$var$U.current.useDeferredValue(a);
};
$4ab0fc1563709023$export$6d9c69b0de29b591 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useEffect(a, b);
};
$4ab0fc1563709023$export$f680877a34711e37 = function() {
    return $4ab0fc1563709023$var$U.current.useId();
};
$4ab0fc1563709023$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useImperativeHandle(a, b, e);
};
$4ab0fc1563709023$export$aaabe4eda9ed9969 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useInsertionEffect(a, b);
};
$4ab0fc1563709023$export$e5c5a5f917a5871c = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useLayoutEffect(a, b);
};
$4ab0fc1563709023$export$1538c33de8887b59 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useMemo(a, b);
};
$4ab0fc1563709023$export$13e3392192263954 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useReducer(a, b, e);
};
$4ab0fc1563709023$export$b8f5890fc79d6aca = function(a) {
    return $4ab0fc1563709023$var$U.current.useRef(a);
};
$4ab0fc1563709023$export$60241385465d0a34 = function(a) {
    return $4ab0fc1563709023$var$U.current.useState(a);
};
$4ab0fc1563709023$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useSyncExternalStore(a, b, e);
};
$4ab0fc1563709023$export$7b286972b8d8ccbf = function() {
    return $4ab0fc1563709023$var$U.current.useTransition();
};
$4ab0fc1563709023$export$83d89fbfd8236492 = "18.3.1";
module.exports["Children"] = $4ab0fc1563709023$export$dca3b0875bd9a954;
module.exports["Component"] = $4ab0fc1563709023$export$16fa2f45be04daa8;
module.exports["Fragment"] = $4ab0fc1563709023$export$ffb0004e005737fa;
module.exports["Profiler"] = $4ab0fc1563709023$export$e2c29f18771995cb;
module.exports["PureComponent"] = $4ab0fc1563709023$export$221d75b3f55bb0bd;
module.exports["StrictMode"] = $4ab0fc1563709023$export$5f8d39834fd61797;
module.exports["Suspense"] = $4ab0fc1563709023$export$74bf444e3cd11ea5;
module.exports["__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED"] = $4ab0fc1563709023$export$ae55be85d98224ed;
module.exports["act"] = $4ab0fc1563709023$export$3ba232387fd5d6dd;
module.exports["cloneElement"] = $4ab0fc1563709023$export$e530037191fcd5d7;
module.exports["createContext"] = $4ab0fc1563709023$export$fd42f52fd3ae1109;
module.exports["createElement"] = $4ab0fc1563709023$export$c8a8987d4410bf2d;
module.exports["createFactory"] = $4ab0fc1563709023$export$d38cd72104c1f0e9;
module.exports["createRef"] = $4ab0fc1563709023$export$7d1e3a5e95ceca43;
module.exports["forwardRef"] = $4ab0fc1563709023$export$257a8862b851cb5b;
module.exports["isValidElement"] = $4ab0fc1563709023$export$a8257692ac88316c;
module.exports["lazy"] = $4ab0fc1563709023$export$488013bae63b21da;
module.exports["memo"] = $4ab0fc1563709023$export$7c73462e0d25e514;
module.exports["startTransition"] = $4ab0fc1563709023$export$7568632d0d33d16d;
module.exports["unstable_act"] = $4ab0fc1563709023$export$88948ce120ea2619;
module.exports["useCallback"] = $4ab0fc1563709023$export$35808ee640e87ca7;
module.exports["useContext"] = $4ab0fc1563709023$export$fae74005e78b1a27;
module.exports["useDebugValue"] = $4ab0fc1563709023$export$dc8fbce3eb94dc1e;
module.exports["useDeferredValue"] = $4ab0fc1563709023$export$6a7bc4e911dc01cf;
module.exports["useEffect"] = $4ab0fc1563709023$export$6d9c69b0de29b591;
module.exports["useId"] = $4ab0fc1563709023$export$f680877a34711e37;
module.exports["useImperativeHandle"] = $4ab0fc1563709023$export$d5a552a76deda3c2;
module.exports["useInsertionEffect"] = $4ab0fc1563709023$export$aaabe4eda9ed9969;
module.exports["useLayoutEffect"] = $4ab0fc1563709023$export$e5c5a5f917a5871c;
module.exports["useMemo"] = $4ab0fc1563709023$export$1538c33de8887b59;
module.exports["useReducer"] = $4ab0fc1563709023$export$13e3392192263954;
module.exports["useRef"] = $4ab0fc1563709023$export$b8f5890fc79d6aca;
module.exports["useState"] = $4ab0fc1563709023$export$60241385465d0a34;
module.exports["useSyncExternalStore"] = $4ab0fc1563709023$export$306c0aa65ff9ec16;
module.exports["useTransition"] = $4ab0fc1563709023$export$7b286972b8d8ccbf;
module.exports["version"] = $4ab0fc1563709023$export$83d89fbfd8236492;

});

parcelRegister("kGrzq", function(module, exports) {
/* eslint-disable no-dupe-class-members */ class $533cd45aab169de9$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}
module.exports["BaseMeasures"] = $533cd45aab169de9$export$31c6869b8bca23f6;

});

parcelRegister("cfnOC", function(module, exports) {

var $jS7pv = parcelRequire("jS7pv");


var $aXes4 = parcelRequire("aXes4");

const $9f91c9896b70f4fe$export$c1822ca48c7f924b = 'analytics-byline';
const $9f91c9896b70f4fe$export$b1568f4c0bd435a7 = 'analytics-dialog-skeleton';
const $9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY = 'analyticsByLine';
const $9f91c9896b70f4fe$var$initSsrEvents = ()=>{
    if (!window.__SSR_EVENTS_CAPTURE__) window.__SSR_EVENTS_CAPTURE__ = {};
    if (!window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]) window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY] = {};
};
const $9f91c9896b70f4fe$var$onByLineEvent = (eventType, event)=>{
    $9f91c9896b70f4fe$var$initSsrEvents();
    if (window && window.__SSR_EVENTS_CAPTURE__ && !window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]) window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY][eventType] = event;
    return;
};
const $9f91c9896b70f4fe$var$onByLineClick = (bylineElem, dialogElem, event)=>{
    $9f91c9896b70f4fe$var$initSsrEvents();
    if (window && window.__SSR_EVENTS_CAPTURE__ && !window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]?.[(0, $aXes4.SSREvent).CLICK]) {
        dialogElem.style.display = 'block';
        // Based on byline position center the dialog skeleton
        const dialogWidth = dialogElem.getBoundingClientRect().width;
        const byLineWidth = bylineElem.getBoundingClientRect().width;
        const dialogLeftOffset = bylineElem.offsetLeft + byLineWidth / 2 - dialogWidth / 2;
        dialogElem.style.left = `${dialogLeftOffset}px`;
        window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY][(0, $aXes4.SSREvent).CLICK] = event;
        window.performance.mark((0, $jS7pv.CLICKED_BYLINE_SSR_MARK));
    }
    return;
};
const $9f91c9896b70f4fe$export$be4c46d3a4a72504 = ()=>{
    const byline = document?.querySelector(`[data-testid="${$9f91c9896b70f4fe$export$c1822ca48c7f924b}"]`);
    const dialog = document?.querySelector(`[data-testid="${$9f91c9896b70f4fe$export$b1568f4c0bd435a7}"]`);
    if (!byline || !dialog) return;
    byline?.addEventListener('click', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineClick(byline, dialog, evt);
    }, true);
    byline?.addEventListener('hover', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineEvent((0, $aXes4.SSREvent).HOVER, evt);
    }, true);
    byline?.addEventListener('focus', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineEvent((0, $aXes4.SSREvent).FOCUS, evt);
    }, true);
};
$9f91c9896b70f4fe$export$be4c46d3a4a72504();
module.exports["TEST_ID_BYLINE"] = $9f91c9896b70f4fe$export$c1822ca48c7f924b;
module.exports["TEST_ID_DIALOG_SKELETON"] = $9f91c9896b70f4fe$export$b1568f4c0bd435a7;
module.exports["addSSREventListeners"] = $9f91c9896b70f4fe$export$be4c46d3a4a72504;

});

parcelRegister("jS7pv", function(module, exports) {
var $d3258a672d0895b9$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    // CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
    TestId["BYLINE"] = "analytics-byline";
    return TestId;
}({});
const $d3258a672d0895b9$export$f79f9d6fd24cf942 = 'analyticsByLine';
const $d3258a672d0895b9$export$5ac4ec80482fdf4b = 'clicked-analytics-byline-fmp-ssr.rendered';
module.exports["TestId"] = $d3258a672d0895b9$export$f067415f668a97e9;
module.exports["SSR_EVENTS_CAPTURE_KEY"] = $d3258a672d0895b9$export$f79f9d6fd24cf942;
module.exports["CLICKED_BYLINE_SSR_MARK"] = $d3258a672d0895b9$export$5ac4ec80482fdf4b;

});

parcelRegister("aXes4", function(module, exports) {
var $4de63777257ade50$export$64176d052f399149 = /*#__PURE__*/ function(SSREvent) {
    SSREvent["CLICK"] = "click";
    SSREvent["HOVER"] = "hover";
    SSREvent["FOCUS"] = "focus";
    return SSREvent;
}({});
module.exports["SSREvent"] = $4de63777257ade50$export$64176d052f399149;

});

parcelRegister("8Oxny", function(module, exports) {
const $100cbce192263f6e$export$4318b8b1b37d5113 = (document1, window1)=>{
    /*Copied from next/packages/comment/src/utils.ts*/ const FABRIC_PAGE_MARKER_REF_ATTRIBUTE = 'data-id';
    const TINY_PAGE_MARKER_REF_ATTRIBUTE = 'data-ref';
    const getHighlightFromMarkerRef = (markerRef, additionalQueryScope = '')=>{
        if (!markerRef) return null;
        // We need to allow for additional query scope to be added to specify particular markerRef comments
        return document1.querySelector(`${additionalQueryScope} [${FABRIC_PAGE_MARKER_REF_ATTRIBUTE}="${markerRef}"], ${additionalQueryScope} [${TINY_PAGE_MARKER_REF_ATTRIBUTE}="${markerRef}"]`);
    };
    const adjustNodeForStickyHeader = (stickyHeaderElement)=>{
        let adjustedElement = stickyHeaderElement;
        const markerRef = getMarkerRef(adjustedElement);
        // If this is exists it's a commited comment, look for its counterpart in the real table
        // TODO: Support new highlights when we allow it
        if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
        adjustedElement = getHighlightFromMarkerRef(markerRef, '.pm-table-wrapper');
        return adjustedElement;
    };
    // Function to calculate a comment's offset taking nested elements into consideration
    const calculateElementOffset = (element, isFabricHighlight)=>{
        let elementOffsetTop = 0;
        let nodeToMeasure = element;
        // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
        // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
        if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) nodeToMeasure = adjustNodeForStickyHeader(nodeToMeasure);
        // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
        // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
        // pages do not have anything like that, but will return null when we get to <body>
        while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper')){
            elementOffsetTop += nodeToMeasure.offsetTop;
            nodeToMeasure = nodeToMeasure.offsetParent;
        }
        if (isFabricHighlight === undefined) return elementOffsetTop;
        else if (isFabricHighlight) {
            const rendererWrapper = document1.querySelector('#content .ak-renderer-wrapper');
            if (rendererWrapper) elementOffsetTop += rendererWrapper.offsetTop;
        } else {
            const pageMetadata = document1.querySelector('#content-body .page-metadata-modification-info');
            if (pageMetadata) elementOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
        }
        return elementOffsetTop;
    };
    const getMarkerRef = (element)=>{
        let markerRef = null;
        if (element) {
            markerRef = element.getAttribute(FABRIC_PAGE_MARKER_REF_ATTRIBUTE);
            if (!markerRef) markerRef = element.getAttribute(TINY_PAGE_MARKER_REF_ATTRIBUTE);
        }
        return markerRef;
    };
    // Function to scroll a comment into view with the correct offsets
    const scrollCommentIntoViewAndFetchOffset = (commentElement, isFabricPage)=>{
        if (!commentElement) return;
        // We may be in an iframe so use window.top
        const currentWindowHeight = window1.innerHeight || window1?.top?.innerHeight;
        const currentPageOffset = window1.scrollY || window1?.top?.scrollY;
        const offset = calculateElementOffset(commentElement) + commentElement.offsetHeight;
        const rendererOffset = document1.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // Stop scrollTo being set if window doesn't provide all the needed info
        if (typeof currentWindowHeight !== 'number' || typeof currentPageOffset !== 'number') return;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            window1.scrollTo({
                top: offset - windowOffset
            });
            return offset - windowOffset;
        }
    };
    const bindSSREventMouseEventHandlers = (target)=>{
        if (!target) return;
        const onClick = (evt)=>{
            if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__) window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ = {};
            const isFabricHighlight = evt.target?.dataset?.markAnnotationType === 'inlineComment';
            const isTinyHighlight = evt.target?.classList?.contains('inline-comment-marker');
            if (isFabricHighlight || isTinyHighlight) {
                if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements']) {
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] = [];
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] = '';
                }
                // Grab offset for InlineCommentsLoadingSkeleton placement
                let markOffsetTop = 0;
                const inlineHighlight = evt.target;
                try {
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].push(inlineHighlight);
                    markOffsetTop = calculateElementOffset(inlineHighlight, Boolean(isFabricHighlight));
                    // Save position for loading state skeletons
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] = markOffsetTop;
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
                // Select sidebar skeleton and show it during ssr
                const sidebar = document1.getElementById('inline-comment-sidebar-skeleton');
                if (sidebar) {
                    sidebar.style.display = 'block';
                    sidebar.style.top = `${markOffsetTop}px`;
                    inlineHighlight.classList.add('active-highlight');
                }
            }
        };
        target.addEventListener('click', onClick, true);
    };
    /* Gets Sorted MarkerRefs in DOM and filters ones returned by back-end API for Unresolved comments */ const getSortedMarkerRefs = (markerRefList, rawMarks)=>{
        const marksArray = Array.from(rawMarks).map((node)=>getMarkerRef(node));
        /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
        duplicates in that case so we can navigate between comments correctly */ const distinctMarks = [
            ...new Set(marksArray)
        ];
        return distinctMarks.filter((mark)=>markerRefList.includes(mark));
    };
    const getFocusedMarkIndex = (markerRefs, focusedMarkerRef)=>{
        const focusedMarkPosition = markerRefs.findIndex((mark)=>mark === focusedMarkerRef);
        return focusedMarkPosition || 0;
    };
    const addFocusedInlineComment = (focusedMarkerRef, markerRefs, marks)=>{
        if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__) {
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ = {};
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] = {};
        }
        const focusedElement = document1.querySelector(`[${FABRIC_PAGE_MARKER_REF_ATTRIBUTE}="${focusedMarkerRef}"]`);
        // If we cannot query for correct focused element we want to exit
        if (!focusedElement) return;
        const sortedMarks = getSortedMarkerRefs(markerRefs, marks);
        const totalHighlights = sortedMarks.length;
        const isFabricHighlight = focusedElement?.dataset?.markAnnotationType === 'inlineComment';
        const isTinyHighlight = focusedElement?.classList?.contains('inline-comment-marker');
        if (isFabricHighlight || isTinyHighlight) {
            const markOffsetTop = calculateElementOffset(focusedElement, Boolean(isFabricHighlight));
            const commentPosition = getFocusedMarkIndex(sortedMarks, focusedMarkerRef);
            const isFabricPage = !!isFabricHighlight;
            const scrollToOffset = scrollCommentIntoViewAndFetchOffset(focusedElement, isFabricPage);
            // Set window values for SPA to read
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'] = markOffsetTop;
            // Set scroll value for page scroll if focusedComment is lower than top
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'] = scrollToOffset;
            // Setting window values from data added to dom in addInlineHighlights
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position'] = commentPosition;
            //Set total Comments
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments'] = totalHighlights;
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRef'] = focusedMarkerRef;
            // Select sidebar skeleton and show it during ssr
            const sidebar = document1.getElementById('focused-inline-comment-sidebar-skeleton');
            // Prevent browser from moving the scroll position around on page load
            if (history) history.scrollRestoration = 'manual';
            /* if markOffsetTop is 0 dont render */ if (sidebar && markOffsetTop) {
                sidebar.style.top = `${markOffsetTop}px`;
                sidebar.style.display = 'block';
                focusedElement.classList.add('active-highlight');
                // Set inline comment number
                const inlineCommentNumberContainer = sidebar.querySelector('#inline-comment-index');
                if (inlineCommentNumberContainer && typeof commentPosition === 'number' && typeof totalHighlights === 'number') inlineCommentNumberContainer.textContent = `${commentPosition + 1} of ${totalHighlights}`;
                window1.performance.mark('focused-inline-comment-fmp-ssr.rendered');
            }
        }
    };
    // Get focused marker ref from data attribute
    const focusedMarkerRef = document1.getElementById('inline-comments-script')?.getAttribute('data-focused');
    /* get markerRefs from data-mark attribute - comes in as a string
      convert to array */ const markerRefs = document1.getElementById('inline-comments-script')?.getAttribute('data-marks')?.split(',');
    if (markerRefs && Array.isArray(markerRefs) && markerRefs.length > 0) {
        const marks = document1.querySelectorAll(`.inline-comment-marker, [data-mark-annotation-type="inlineComment"]`);
        /* Handle Focused Comment SSR */ if (focusedMarkerRef) addFocusedInlineComment(focusedMarkerRef, markerRefs, marks);
        else /* Add click listeners to SSR'd inline comments - not for focused inline comment page */ Array.from(marks).forEach((el)=>{
            /* get markerRef from data-id for fabric, data-ref for tiny*/ const markerRef = el.getAttribute(FABRIC_PAGE_MARKER_REF_ATTRIBUTE) || el.getAttribute(TINY_PAGE_MARKER_REF_ATTRIBUTE);
            if (markerRef && markerRefs?.includes(markerRef)) bindSSREventMouseEventHandlers(el);
        });
    }
};
$100cbce192263f6e$export$4318b8b1b37d5113(document, window);
module.exports["addSSRClickListeners"] = $100cbce192263f6e$export$4318b8b1b37d5113;

});

parcelRegister("kHAdr", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

const $b7aa9cbf24a2d47a$var$setAjsMetadata = ()=>{
    (0, $3d5UI.waitForGlobal)({
        listener: 'ssrLegacyBridge',
        globalProperty: 'AJS.Meta.set',
        interval: 50
    }, ()=>{
        const ajsMetaParamsStr = window.__SSR_AJS_META__;
        let ajsMetaParams = [];
        try {
            ajsMetaParams = JSON.parse(ajsMetaParamsStr);
        } catch (error) {
        /* NOOP */ }
        // We have 2 legacy bridge here based on graphql
        // Another in packages/confluence-frontend-server/src/components/LegacyBridge/LegacyBridge.js
        // based on Redux. We need to let the legacy one know we have already dealt with these meta
        // tags don't override.
        if (ajsMetaParams?.length > 0) {
            window.AJS.Meta.set('has-next-legacy-bridge', true);
            ajsMetaParams.forEach(({ key: key, value: value })=>{
                window.AJS.Meta.set(key, value);
                // This logic is to match the classic LegacyBridge, as apparently it was missing in
                // the LegacyBridgeNext and some macros rely on AJS.params as opposed to AJS.Meta.
                if (key === 'page-id') window.AJS.params.pageId = value;
                if (key === 'space-key') window.AJS.params.spaceKey = value;
            });
        }
    });
};
$b7aa9cbf24a2d47a$var$setAjsMetadata();

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("kRdFo", function(module, exports) {

var $dkxaU = parcelRequire("dkxaU");

const $3d9ba5a7bda7cf88$export$9f1e476260e32cbb = (document1)=>{
    // Only run script if found this element
    const enableScript = document1.querySelector('[data-id="ssr-cover-picture-dimension"]');
    if (!enableScript) return;
    const editorParent = document1.querySelector('.fabric-editor-popup-scroll-parent');
    const parentWidth = editorParent?.clientWidth || 0;
    if (!parentWidth) return;
    const coverImageWrapper = document1.querySelector('[data-id="cover-pic-and-button-wrapper"]');
    if (!coverImageWrapper) return;
    const height = (0, $dkxaU.calcDynamicCoverImageHeight)(parentWidth);
    coverImageWrapper.style.width = `${parentWidth}px`;
    coverImageWrapper.style.height = `${height}px`;
};
$3d9ba5a7bda7cf88$export$9f1e476260e32cbb(document);
module.exports["upateCoverPictureDimension"] = $3d9ba5a7bda7cf88$export$9f1e476260e32cbb;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;

});


var $5nRL1 = parcelRequire("5nRL1");


var $hZpML = parcelRequire("hZpML");

const $6f7e28bb4a7687f7$var$dataLoadableBeginRegex = /data-loadable-begin="([^"]*)"/;
const $6f7e28bb4a7687f7$var$dataLoadableEndRegex = /data-loadable-end="([^"]*)"/;
const $6f7e28bb4a7687f7$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER = 2;
function $6f7e28bb4a7687f7$var$findEndMarker(root, loadableId) {
    if (!root) return null;
    let el = root;
    while(el = el.nextSibling){
        if (el.nodeType !== Node.COMMENT_NODE) continue;
        const match = el?.nodeValue?.match($6f7e28bb4a7687f7$var$dataLoadableEndRegex);
        if (match && match[1] === loadableId) return el;
    }
    return null;
}
function $6f7e28bb4a7687f7$export$8276aefd9449c44b(root = document.body) {
    if (!window.__SSR_RENDERED__) return;
    try {
        const nodes = root.childNodes;
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const nodeType = node.nodeType;
            if (nodeType === Node.COMMENT_NODE) {
                const match = node.nodeValue?.match($6f7e28bb4a7687f7$var$dataLoadableBeginRegex);
                if (match) {
                    const loadableId = match[1];
                    // We found a begin marker
                    let insertionPoint = node;
                    while(insertionPoint.nextSibling)insertionPoint = insertionPoint.nextSibling;
                    if (!insertionPoint.parentNode) continue;
                    // Now let's find the end
                    let endMarker = null;
                    let beginMarker = node;
                    let moveUpLevelCount = 0;
                    while(!(endMarker = $6f7e28bb4a7687f7$var$findEndMarker(beginMarker, loadableId)) && moveUpLevelCount <= $6f7e28bb4a7687f7$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER){
                        // We can't find it, go up a level
                        if (beginMarker.parentNode) {
                            beginMarker = beginMarker.parentNode;
                            moveUpLevelCount++;
                        } else break;
                    }
                    // Now we have a pairing end. Check if they are already siblings
                    if (endMarker && endMarker.parentNode === insertionPoint.parentNode) continue;
                    // Move the nodes
                    if (endMarker && endMarker.parentNode && beginMarker.parentNode === endMarker.parentNode) {
                        let nextSibling = endMarker.nextSibling;
                        let node = endMarker;
                        while(node && node !== beginMarker){
                            const previousSibling = node.previousSibling;
                            insertionPoint.parentNode.insertBefore(node, insertionPoint.nextSibling);
                            node = previousSibling;
                        }
                        // In the case where there are inline text following the macro, we need to move these nodes as well
                        // Move all nodes up until the last dangling empty tag
                        while(nextSibling && nextSibling.nodeName !== beginMarker.nodeName){
                            const nodeToMove = nextSibling;
                            nextSibling = nextSibling.nextSibling;
                            beginMarker.appendChild(nodeToMove);
                        }
                        /**
						 * <p><span>foo<div>something</div></span>bar</p>
						 * will become
						 * <p><span>foo</span></p><div>something</div>bar<p></p>
						 * Remove the last dangling empty tag
						 */ if (nextSibling instanceof HTMLElement && nextSibling.nodeName === beginMarker.nodeName && !nextSibling.innerHTML) nextSibling.parentNode?.removeChild(nextSibling);
                    }
                }
            } else if (nodeType === Node.ELEMENT_NODE) $6f7e28bb4a7687f7$export$8276aefd9449c44b(node);
        }
    } catch (e) {}
}


window?.performance?.mark?.(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).SSR_AFTER_SCRIPTS}.start`);
// Code in this file runs after HTML body
(0, $6f7e28bb4a7687f7$export$8276aefd9449c44b)();




if (window.__SSR_RENDERED__) {
    if (!window.__DELAY_COLLECT_SSR_PLACEHOLDERS__) (0, $5nRL1.collectSSRPlaceholderDimensions)(document, window);
    (parcelRequire("cfnOC"));
    (parcelRequire("8Oxny"));
    (parcelRequire("kHAdr"));
    (parcelRequire("kRdFo"));
}
window?.performance?.mark?.(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).SSR_AFTER_SCRIPTS}.end`);


//# sourceMappingURL=ssr-scripts-after.c5474922.js.map
